import React from 'react';
import { Link } from 'react-router-dom';
import { flixButton, flixUi } from '../styles/flixUiTheme';
import SystemIcon from '../components/ui/SystemIcon';
import { CONTACT_LINKS, getSupportMailto } from '../config/contactLinks';

function AccessDeniedPage() {
  return (
    <main
      style={{
        position: 'relative',
        minHeight: '100vh',
        color: flixUi.text,
        fontFamily: flixUi.fontFamily,
        overflow: 'hidden',
        display: 'grid',
        placeItems: 'center',
        padding: 'clamp(1rem, 3vw, 2rem)',
        background: '#000',
      }}
    >
      <style>{`
        @keyframes vf403FadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes vf403RiseIn {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .vf-403-cta {
          transition: transform 200ms ease, border-color 200ms ease, background 200ms ease;
        }
        .vf-403-cta:hover,
        .vf-403-cta:focus-visible {
          transform: translateY(-1px);
        }
        .vf-403-cta-secondary:hover,
        .vf-403-cta-secondary:focus-visible {
          border-color: rgba(255,255,255,0.78) !important;
          background: rgba(255,255,255,0.24) !important;
        }
        .vf-403-content {
          transform: translateY(0);
        }
        .vf-403-headline {
          position: static;
          white-space: nowrap;
        }
        .vf-403-headline-break {
          display: inline;
        }
        .vf-403-help {
          bottom: clamp(1.2rem, 4vh, 3rem);
        }
        @media (orientation: portrait) and (max-width: 1024px) {
          .vf-403-content {
            transform: translateY(clamp(2rem, 8vh, 7rem));
          }
          .vf-403-headline {
            position: relative;
            top: clamp(-1.2rem, -3vh, -2.2rem);
            white-space: normal;
          }
          .vf-403-headline-break {
            display: block;
          }
          .vf-403-help {
            bottom: clamp(1.2rem, 3.8vh, 2.4rem);
          }
        }
      `}</style>

      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'url(https://res.cloudinary.com/da1u9kl5f/image/upload/v1771850949/pexels-flux-1140230780-31213602_i7uej3.jpg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center 34%',
          transform: 'scale(1.02)',
        }}
      />

      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.56))',
        }}
      />

      <div
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'radial-gradient(130% 95% at 50% 50%, rgba(0,0,0,0.05) 0%, rgba(0,0,0,0.38) 54%, rgba(0,0,0,0.84) 100%)',
        }}
      />

      <section
        className="vf-403-content"
        style={{
          position: 'relative',
          zIndex: 1,
          textAlign: 'center',
          width: '100%',
          maxWidth: 760,
          padding: 'clamp(0.8rem, 2.8vh, 2rem) clamp(0.8rem, 2.6vw, 1.4rem)',
          animation: 'vf403FadeIn 620ms ease both, vf403RiseIn 520ms ease both',
        }}
      >
        <h1
          className="vf-403-headline"
          style={{
            fontSize: 'clamp(2rem, 5.4vw, 4rem)',
            lineHeight: 1.06,
            letterSpacing: flixUi.titleLetterSpacing,
            fontWeight: flixUi.headingWeight,
            margin: 0,
          }}
        >
          This Premiere
          {' '}
          <span className="vf-403-headline-break">Is Invite-Only.</span>
        </h1>

        <p
          style={{
            margin: 'clamp(1rem, 2.6vh, 1.8rem) auto 0',
            maxWidth: 700,
            color: flixUi.textMuted,
            fontSize: 'clamp(1rem, 2vw, 1.25rem)',
            lineHeight: 1.42,
            marginBottom: 0,
          }}
        >
          It looks like you don&apos;t have tickets to this show.
        </p>
        <p
          style={{
            margin: 'clamp(1.3rem, 3.5vh, 2.3rem) auto 0',
            maxWidth: 700,
            color: flixUi.textMuted,
            fontSize: 'clamp(1rem, 2vw, 1.25rem)',
            lineHeight: 1.42,
          }}
        >
          Log in with the linked account,
          <br />
          or contact our ticket desk for assistance.
        </p>

        <div
          style={{
            marginTop: 'clamp(2rem, 5.4vh, 3.8rem)',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '0.78rem',
          }}
        >
          <Link
            to="/login"
            className="vf-403-cta"
            style={{
              ...flixButton,
              background: '#fff',
              color: '#000',
              textDecoration: 'none',
              minWidth: 170,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
            }}
          >
            <SystemIcon icon="play" size={14} alt="" tone="muted" />
            Login
          </Link>
          <Link
            to="/"
            className="vf-403-cta vf-403-cta-secondary"
            style={{
              ...flixButton,
              background: 'rgba(255,255,255,0.18)',
              border: `1px solid ${flixUi.borderStrong}`,
              color: '#fff',
              textDecoration: 'none',
              minWidth: 170,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 8,
            }}
          >
            <SystemIcon icon="home" size={14} alt="" />
            Return Home
          </Link>
        </div>

      </section>

      <div
        className="vf-403-help"
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          zIndex: 1,
          textAlign: 'center',
          padding: '0 1rem',
        }}
      >
        <p
          style={{
            margin: 0,
            color: '#cfd3db',
            fontSize: 'clamp(0.84rem, 1.65vw, 0.98rem)',
          }}
        >
          Need help?
        </p>
        <p
          style={{
            marginTop: '0.28rem',
            marginBottom: 0,
            color: flixUi.textSubtle,
            fontSize: 'clamp(0.82rem, 1.75vw, 0.95rem)',
          }}
        >
          <a
            href={CONTACT_LINKS.dmUrl}
            target="_blank"
            rel="noreferrer"
            style={{ color: 'inherit', textDecoration: 'underline', display: 'inline-flex', alignItems: 'center', gap: 5 }}
          >
            <SystemIcon icon="sparkles" size={12} alt="" tone="muted" />
            DM us
          </a>
          {' · '}
          <a
            href={getSupportMailto()}
            style={{ color: 'inherit', textDecoration: 'underline', display: 'inline-flex', alignItems: 'center', gap: 5 }}
          >
            <SystemIcon icon="mail" size={12} alt="" tone="muted" />
            Email us
          </a>
        </p>
      </div>
    </main>
  );
}

export default AccessDeniedPage;
